module.exports = __webpack_public_path__ + "media/images/job_list/icon_bridal_01-c1a16afeedafa8b0a01382e57d0cc4cb.png";